import React from 'react';
import ReactDOM from 'react-dom';
import App from './pages/App';  

ReactDOM.render(<App/>, document.querySelector('#root'));